/**
 * Standard Outlook action tooltip / title copy.
 * Sync = pull from Microsoft Graph. Refresh = reload FRODO data only.
 * Prefer these strings (or extend here) in later polish areas.
 */

export const outlookTooltipCopy = {
  /** Cap-raise Emails toolbar Sync */
  syncOutlook:
    'Pull new mail from your connected Outlook mailbox into this raise',
  /** Cap-raise page-level Sync inbox */
  syncInbox:
    'Pull new Outlook messages into the system (syncs your whole connected mailbox, rate-limited).',
  /** Emails / campaigns list Refresh */
  refreshList:
    'Reload this list from FRODO — does not pull new Outlook mail',
  /** Investor list Refresh */
  refreshInvestors:
    'Refresh this investor list (does not sync Outlook)',
  refreshActivity:
    'Reload activity from FRODO — does not pull new Outlook mail',
  viewRecipients: 'View recipients for this campaign',
  followUp: 'Open the follow-up list. People who have not replied start ticked.',
  noRecipientDetail: 'No recipient detail for this event',
  openInvestor: 'Open this investor on the raise',
  /** Admin campaigns drawer — Open investor deep-link */
  openInvestorAdmin: 'Open this investor in Admin Investors',
  /** Cap-raise Activity — close recipients */
  closeRecipients: 'Close recipients and return to Activity',
  /** Admin campaigns — close recipients */
  closeRecipientsAdmin: 'Close recipients and return to campaigns list',
  /** Admin campaigns table — client raise link */
  openRaiseTargets: 'Open Cap-raise Target Investors for this client',
  outlookWeb:
    'Opens Outlook on the web. Sign in with your Microsoft account if prompted.',
  outlookWebMissing: 'Outlook link not available for this message',
  reply: 'Reply to this message in FRODO',
  replyAll: 'Reply to sender and all recipients in FRODO',
  replyInOutlook: 'Open in Outlook on the web to reply to this message',
  viewOnlyThread:
    'You can read this thread. Send and reply stay with the connected Outlook mailbox.',
  viewMessage: 'View message',
  hideMessage: 'Hide message',
  closeMessage: 'Close message',
  earlierMessage: 'Open this message in the drawer',
  expandConversation: 'Show the other messages in this conversation',
  collapseConversation: 'Hide the other messages in this conversation',
  applyTemplateBody:
    'Apply the selected template body (and subject hint if Subject is empty)',
  selectTemplateToManage: 'Select a template first',
  sharedTemplateAuthorOnly:
    'Only the person who saved this raise template can rename, update, or delete it',
  saveTemplateJustMe: 'Save for yourself only across your raises and replies',
  saveTemplateThisRaise: 'Share with Voluntas team members on this capital raise',
  renameTemplate: 'Rename this saved template',
  updateTemplateBody: 'Overwrite the saved template with the current message body',
  deleteTemplate: 'Delete this saved template',
  includeSignature: 'Append your FRODO signature from Settings when sending',
  saveAsTemplate: 'Save the current body as a reusable template for Cap-raise and replies',
  sendCampaign: 'Queue this campaign to send via your connected Outlook mailbox',
  sendReply: 'Send this reply via your connected Outlook mailbox',
  composeOptions: 'Campaign name, signature, and memo attach',
  composeTemplates: 'Apply, save, rename or delete message templates',
  replyOptions: 'Signature settings for this reply',
  insertImage: 'Insert image (https upload; sent as inline attachment)',
  sendViaOutlook:
    'Compose and queue an Outlook email to this investor from FRODO',
  doNotEmail:
    'When Yes, Outlook campaign sends skip this investor (admin toggle)',
  deleteInvestor: 'Permanently delete this investor after confirmation',
  connectMicrosoft:
    'Sign in with Microsoft to send and sync Outlook mail from FRODO',
  reconnectMicrosoft:
    'Re-authorize Microsoft so sending and inbox sync work again',
  disconnectMicrosoft:
    'Stop using this Microsoft mailbox in FRODO (does not delete logged emails)',
  insertSignatureLogo:
    'Insert a logo at your cursor (replaces any existing logo). PNG/JPEG/WebP/GIF, max 2MB',
  moveSignatureLogo:
    'Click a line in your signature, then click here to move your logo to that spot',
  /** Cap-raise Email menu — empty selection */
  emailSelectFirst: 'Select who you wish to email before this becomes available',
  /** Cap-raise Email menu — selection ready */
  emailSelected: 'Email selected investors via Outlook or BCC',
  /** Cap-raise Email menu — Outlook item (connected) */
  sendViaOutlookMenu: 'Compose in FRODO and send via connected Outlook',
  /** Cap-raise Email menu — Outlook item (disconnected) */
  outlookNotConnectedMenu: 'Connect Outlook in Settings',
  /** Cap-raise Email menu — BCC fallback */
  emailBccFallback: 'Open your mail app with To + BCC',
  exportTargetList: 'Export target list as CSV or Excel',
  exportEmpty: 'No investors to export',
  importInvestors: 'Add or import investors',
} as const;

export type OutlookTooltipKey = keyof typeof outlookTooltipCopy;

